import React, { type ReactNode, useEffect, useRef } from "react";

import { SupText } from "@repo/core-ui";
import { escapedNewLineToLineBreakTag, hexToRGBA, unescapeDescription } from "@/utils";

interface UiDetailsAboutProps {
  aboutText: string;
  chart: ReactNode;
  table: ReactNode;
  colors: {
    color: string;
    contrastColor: string;
  };
}

export default function UiDetailsAbout({ aboutText, chart, table, colors }: UiDetailsAboutProps) {
  const aboutRef = useRef<HTMLDivElement>(null);
  const tableRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const tableHeight = tableRef.current?.clientHeight;
    if (aboutRef.current && tableHeight) {
      aboutRef.current.style.maxHeight = `${tableHeight}px`;
    }
  }, [aboutRef, tableRef]);

  return (
    <div
      className="mx-4 my-6 flex min-h-[368px] flex-col gap-6 rounded-bl-[48px] rounded-br-[48px] rounded-tl-[48px] bg-primary-50 px-4 py-6 text-neutral-900 md:mx-6 md:px-6"
      style={{ backgroundColor: hexToRGBA(colors.color, 0.08) }}
    >
      <div className="flex flex-col gap-4 lg:flex-row">
        <div className="custom-scrollbar flex-1 overflow-y-auto" ref={aboutRef}>
          <SupText variant="subtitle1" className="whitespace-pre-wrap leading-5">
            {escapedNewLineToLineBreakTag(unescapeDescription(aboutText))}
          </SupText>
        </div>
        <div className="flex-1 uppercase xl:flex-[2]" ref={tableRef}>
          {table}
        </div>
      </div>
      <div className="w-full">{chart}</div>
    </div>
  );
}
